export default __webpack_public_path__ + "static/media/2-3.143c2a01.png";